<template>
  <video id="myVideo" class="video-js vjs-default-skin" playsinline></video>
</template>

<script>
/* eslint-disable */
import "video.js/dist/video-js.css";
import "videojs-record/dist/css/videojs.record.css";
import videojs from "video.js";

import "webrtc-adapter";
import RecordRTC from "recordrtc";

import WaveSurfer from "wavesurfer.js";
import MicrophonePlugin from "wavesurfer.js/dist/plugin/wavesurfer.microphone.js";
WaveSurfer.microphone = MicrophonePlugin;

import videojs_wavesurfer_css from "videojs-wavesurfer/dist/css/videojs.wavesurfer.css";
import Wavesurfer from "videojs-wavesurfer/dist/videojs.wavesurfer.js";

import Record from "videojs-record/dist/videojs.record.js";

export default {
  name: "TaskVideoRec",
  data() {
    return {
      player: "",
      options: {
        controls: true,
        width: 150,
        height: 150,
        fluid: false,
        bigPlayButton: false,
        controlBar: {
          volumePanel: false,
          fullscreenToggle: false
        },
        plugins: {
          record: {
            screen: true,
            audio: false,
            video: true,
            displayMilliseconds: false
          }
        }
      }
    };
  },
  methods: {},
  mounted() {
    /* eslint-disable no-console */
    this.player = videojs("#myVideo", this.options, () => {
      // print version information at startup
      let msg =
        "Using video.js " +
        videojs.VERSION +
        " with videojs-record " +
        videojs.getPluginVersion("record") +
        " and recordrtc " +
        RecordRTC.version;
      videojs.log(msg);
    });

    // device is ready
    this.player.on("deviceReady", () => {});

    // user clicked the record button and started recording
    this.player.on("startRecord", () => {});

    // user completed recording and stream is available
    this.player.on("finishRecord", () => {
      // the blob object contains the recorded data that
      // can be downloaded by the user, stored on server etc.

      this.$emit("videoRec", this.player.recordedData);
      this.$emit("closeRec");
    });

    // error handling
    this.player.on("error", (element, error) => {});

    // this.player.on('deviceError', () => {
    // });
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>
